<div class="flexbox-container flex-vertical-centered" [ngClass]="{'up-color': direction === 'up', 'down-color': direction === 'down', 'stay-color': direction === 'stay'}">
  <ng-container *ngIf="!withoutPercentage">
    <div class="percentage" *ngIf="trend < 1 && trend > 0">{{ trend | number:'1.2-2' }} %</div>
    <div class="percentage" *ngIf="trend >= 1 || trend === 0">{{ trend | number:'1.0-0' }} %</div>
  </ng-container>
  <div>
    <i class="fa" [ngClass]="{'fa-arrow-up': direction === 'up', 'fa-arrow-down': direction === 'down', 'fa-arrow-right': direction === 'stay'}"></i>
  </div>
</div>
